<template>
  <div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="year" label="year" width="auto" :min-width="180"></el-table-column>
      <el-table-column label="Price/earnings ratio">
        <el-table-column prop="a" label="Year end" width="auto" :min-width="180"></el-table-column>
        <el-table-column prop="a" label="Open" width="auto" :min-width="180"></el-table-column>
        <el-table-column prop="a" label="High" width="auto" :min-width="180"></el-table-column>
        <el-table-column prop="a" label="Low" width="auto" :min-width="180"></el-table-column>
        <el-table-column prop="a" label="Average" width="auto" :min-width="180"></el-table-column>
      </el-table-column>
      <el-table-column label="Earnings yield (%)">
        <el-table-column prop="a" label="Year end" width="auto" :min-width="180"></el-table-column>
        <el-table-column prop="a" label="Open" width="auto" :min-width="180"></el-table-column>
        <el-table-column prop="a" label="High" width="auto" :min-width="180"></el-table-column>
        <el-table-column prop="a" label="Low" width="auto" :min-width="180"></el-table-column>
        <el-table-column prop="a" label="Average" width="auto" :min-width="180"></el-table-column>
      </el-table-column>
      <el-table-column prop="a" label="Price / cash flow ratio" width="auto" :min-width="180"></el-table-column>
      <el-table-column label="Dividend yield (%)">
        <el-table-column prop="a" label="Year end" width="auto" :min-width="180"></el-table-column>
        <el-table-column prop="a" label="Open" width="auto" :min-width="180"></el-table-column>
        <el-table-column prop="a" label="High" width="auto" :min-width="180"></el-table-column>
        <el-table-column prop="a" label="Low" width="auto" :min-width="180"></el-table-column>
        <el-table-column prop="a" label="Average" width="auto" :min-width="180"></el-table-column>
      </el-table-column>
      <el-table-column prop="a" label="Dividend payout (%)" width="auto" :min-width="180"></el-table-column>
      <el-table-column label="Price/book value ratio">
        <el-table-column prop="a" label="Year end" width="auto" :min-width="180"></el-table-column>
        <el-table-column prop="a" label="Open" width="auto" :min-width="180"></el-table-column>
        <el-table-column prop="a" label="High" width="auto" :min-width="180"></el-table-column>
        <el-table-column prop="a" label="Low" width="auto" :min-width="180"></el-table-column>
        <el-table-column prop="a" label="Average" width="auto" :min-width="180"></el-table-column>
      </el-table-column>
      <el-table-column
        prop="a"
        label="Market Capitalisation / shareholders funds"
        width="auto"
        :min-width="180"
      ></el-table-column>
      <el-table-column
        prop="a"
        label="Market capitalisation / Total assets (Tobin’s Q)"
        width="auto"
        :min-width="180"
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
// element table  循环写多列会有问题  单独写组建
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  }
};
</script>